/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1PersonIdDeactivate202,
  PatchApiV1PersonIdDeactivate401,
  PatchApiV1PersonIdDeactivate404,
  PatchApiV1PersonIdDeactivate500,
  PatchApiV1PersonIdDeactivateMutationResponse,
  PatchApiV1PersonIdDeactivatePathParams,
} from "../../types/personRegisterController/PatchApiV1PersonIdDeactivate.ts";

export const patchApiV1PersonIdDeactivatePathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PatchApiV1PersonIdDeactivatePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1PersonIdDeactivate202Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdDeactivate202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1PersonIdDeactivate401Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdDeactivate401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1PersonIdDeactivate404Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdDeactivate404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1PersonIdDeactivate500Schema =
  z.any() as unknown as ToZod<PatchApiV1PersonIdDeactivate500>;

export const patchApiV1PersonIdDeactivateMutationResponseSchema = z.lazy(
  () => patchApiV1PersonIdDeactivate202Schema,
) as unknown as ToZod<PatchApiV1PersonIdDeactivateMutationResponse>;
